export enum CreatedByOrgTypeEnum {
  BUYER = 'BUYER',
  SELLER = 'SELLER',
  GPO = 'GPO',
}

export enum CrossOpinionEnum {
  DISPUTE = 'dispute',
  APPROVE = 'approve',
  NO_OPINION = 'no_opinion',
  REVIEW = 'review',
}

export enum CrossVizientOpinionEnum {
  DENIED = 'DENIED',
  APPROVED = 'APPROVED',
  NO_OPINION = 'NO_OPINION',
}

export enum CrossOpinionOptionKeysEnum {
  CURRENT_PRODUCT = 'CURRENT_PRODUCT',
  FUNCTIONAL_EQUIVALENT = 'FUNCTIONAL_EQUIVALENT',
  NO_OPINION = 'NO_OPINION',
  REVIEW_ATTRIBUTES = 'REVIEW_ATTRIBUTES',
  TRIAL = 'TRIAL',
  UNACCEPTABLE = 'UNACCEPTABLE',
}

export enum CrossReferenceType {
  PRIMARY = 'PRIMARY',
  ALTERNATE = 'ALTERNATE',
  NO_MATCH = 'NO_MATCH',
}

export enum CrossReferenceDescription {
  BUYER_PRIMARY = 'Buyer recommends - Primary',
  BUYER_ALTERNATE = 'Buyer recommends - Alternate',
  SELLER_PRIMARY = 'Seller recommends - Primary',
  SELLER_ALTERNATE = 'Seller recommends - Alternate',
  NO_MATCH = 'No Equivalent Cross',
  VIZIENT_CROSS = 'Vizient Cross',
}
